import {NgModule} from '@angular/core';
import {RequestOptions} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {ConfirmDialogModule, GrowlModule, SidebarModule, TerminalModule} from 'primeng/primeng';

import {CustomRequestOptions} from './custom-request-options';

import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {NavigationComponent} from '@catapp/modules/base-app/components/navigation/navigation.component';
import {RestangularConfigFactory} from '@catapp/modules/base-app/lib/restangular-config';
import {GlobalConfigResolve} from '@catapp/modules/base-app/services/global-config.resolve';
import {CoreModule} from '@catcore/core.module';
import {ResourceTargetsService, ResourceWizardTargetsService} from '@catcore/types/services';
import {ProjectDetailsModule} from '@catdetails/project-details.module';
import {FeaturesModule} from '@catfeatures/features.module';
import {NgxHttpLoaderModule} from '@catloader/ngx-http-loader.module';
import {SlideInModalModule} from '@catmodules/widgets/slide-in-modal/slide-in-modal.module';
import {ProjectModule} from '@catproject/project.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {EffectsModule} from '@ngrx/effects';
import {RestangularModule} from 'ngx-restangular';
import {appRoutes} from './app.routing';
import {AppComponent} from './components/app-component/app.component';
import {ContentContainerComponent} from './components/content-container/content-container.component';
import {ModelEditorModule} from "@catmodules/model-editor/model-editor.module";
import {CommonModule} from "@angular/common";

const imports = [
  BrowserModule,
  HttpClientModule,
  GrowlModule,
  //TerminalModule,
  //SidebarModule,
  CommonModule,

  StoreModule.forRoot({}),
  EffectsModule.forRoot([]),
  RestangularModule.forRoot(RestangularConfigFactory),
  StoreDevtoolsModule.instrument(),

  NgxHttpLoaderModule,

  /* project */
  CoreModule,
  ProjectModule,
  ProjectDetailsModule,
  FeaturesModule,
  UIBaseModule,
  ModelEditorModule,
  ConfirmDialogModule,

  /* app */
  SlideInModalModule.forRoot(),
  // routingModule,
  RouterModule.forRoot(appRoutes),
];
const declarations = [
  AppComponent,
  NavigationComponent,
  ContentContainerComponent,
];
const providers = [
  {provide: RequestOptions, useClass: CustomRequestOptions},
  GlobalConfigResolve,
  ResourceTargetsService,
  ResourceWizardTargetsService,
];

/**
 * The root module. Embedded in the main.ts file
 */
@NgModule({
  imports,
  declarations,
  providers,
  bootstrap: [
    AppComponent,
  ],
})
export class AppModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/base-app/app.module.ts